import * as React from 'react';
import { OffersTenMinutes } from '../../components/OffersTenMinutes';
import { Advantages } from '../../components/Advantages';
import { Steps } from '../../components/Steps';
import { BanksListContainer } from '../../containers/BanksListContainer';
import { ShowcaseN1 } from '../../components/ShowcaseN1';
import { SubmitPhoneFormContainer } from '../../containers/SubmitPhoneFormContainer';
import { Notes } from '../../components/Notes';
import { ContactUs } from '../../components/ContactUs';
import { InterestRateContainer } from '../../containers/InterestRateContainer/InterestRateContainer';

export const N1Page = () => {
  return (
    <>
      <SubmitPhoneFormContainer Form={ShowcaseN1} label="main_login_block" />
      <BanksListContainer />
      <Steps />
      <OffersTenMinutes />
      <InterestRateContainer />
      <Advantages />
      <ContactUs />
      <Notes />
    </>
  );
};
